import { NoopComponent } from '@components/Noop';
import { isOptimizelyDisabled } from 'lib/global';
import { OptimizelyProvider as ActualProvider } from './OptimizelyWrapper';

export const OptimizelyProvider = isOptimizelyDisabled
    ? NoopComponent
    : ActualProvider;
